import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FieldType } from '@ngx-formly/core';
import { ContextService, LayoutInterface } from '../../context.service';

@Component({
  selector: 'mutara-dialog',
  template: `
<main cdkTrapFocus>
  <form matForm #dynamicDialog>
      <h1 mat-dialog-title>{{data.title ?? title}}</h1>
      <div mat-dialog-content> 
        @if ( !!data.definition ) {
        <table >
          @for ( dataField of data.definition.dataColumns; track dataField.key ) {
        <tr>
        <td>{{dataField.props.label}}</td>
        <td>{{data.model[dataField.key.toString()]}}</td>
        </tr>
          }
        </table>
        }
        <span>{{data.textContent ?? textContent}}</span>
      </div>
  </form>
</main>`,
  styleUrls: ['./dialog.component.scss'],
  standalone: false
})
export class DialogComponent extends FieldType implements OnInit {

  layout: LayoutInterface | undefined;
  title: string = '';
  textContent: string = '';

  /**
   * Class implementation
   * @param contextSettings 
   * @param dialogRef 
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private contextSettings: ContextService,
    private dialogRef: MatDialogRef<DialogComponent>
  ) {
    super();
    this.contextSettings.subscribeTo("layoutIdentity", {
      next: (layout: LayoutInterface) => {
        this.layout = layout;
      }
    });
  }

  ngOnInit() { }

  close() {
    this.dialogRef.close();
  }
}
